import { getNormalisedPerformanceFFs } from '@atlassian/jira-common-long-task-metrics/src/common/util/collectors.tsx';
import {
	fireTrackAnalytics,
	fireOperationalAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { scheduleAfterRender } from '@atlassian/jira-software-react-scheduler/src/index.tsx';
import { getBacklogCardCount } from '../../../../services/performance/backlog-data-collector/index.tsx';
import {
	createSprintInteraction,
	deleteSprintInteraction,
} from '../../../../services/utils/performance-analytics/index.tsx';
import type {
	SprintCreateFailureAction,
	SprintCreateRequestAction,
	SprintCreateSuccessAction,
} from '../../../actions/sprints/create/index.tsx';
import type {
	SprintDeleteRequestAction,
	SprintDeleteSuccessAction,
} from '../../../actions/sprints/delete/index.tsx';
import type { State } from '../../../reducers/types.tsx';

export const sprintCreateRequestPerformance =
	() => (preState: State, state: State, action: SprintCreateRequestAction) => {
		const concurrentId = action.payload.temporaryCardListId;
		createSprintInteraction(concurrentId).start();
		scheduleAfterRender(() => {
			createSprintInteraction(concurrentId).mark('feedback');
		});
		return null;
	};

export const sprintCreateSuccessPerformance =
	() => (preState: State, state: State, action: SprintCreateSuccessAction) => {
		const concurrentId = String(action.payload.temporaryCardListId);
		createSprintInteraction(concurrentId).stop({
			customData: {
				...getNormalisedPerformanceFFs(),
				...getBacklogCardCount(state),
			},
		});
		return null;
	};

export const sprintDeleteRequestPerformance =
	() => (preState: State, state: State, action: SprintDeleteRequestAction) => {
		const concurrentId = action.payload.sprintId;
		deleteSprintInteraction(concurrentId).start();

		scheduleAfterRender(() => {
			deleteSprintInteraction(concurrentId).mark('feedback');
		});
		return null;
	};

export const sprintDeleteSuccessPerformance =
	() => (preState: State, state: State, action: SprintDeleteSuccessAction) => {
		const concurrentId = action.payload.sprintId;
		deleteSprintInteraction(concurrentId).stop({
			customData: {
				...getNormalisedPerformanceFFs(),
				...getBacklogCardCount(state),
			},
		});
	};

export const sprintCreateSuccess =
	() => (preState: State, state: State, action: SprintCreateSuccessAction) => {
		const {
			payload,
			meta: { analyticsEvent },
		} = action;

		if (!analyticsEvent) {
			return null;
		}

		const trackEvent = analyticsEvent.clone();
		if (trackEvent) {
			const didSprintCreateWithDefaultDates = Boolean(payload.sprint.sprintData?.startDate);

			fireTrackAnalytics(trackEvent, 'sprint created', {
				didSprintCreateWithDefaultDates,
				sprintId: payload.sprint.id,
			});
		}

		const opEvent = analyticsEvent.clone();
		if (opEvent) {
			fireOperationalAnalytics(opEvent, 'ui taskSuccess', {
				task: 'createSprint',
			});
		}

		return null;
	};

export const sprintCreateFailure =
	() => (preState: State, state: State, action: SprintCreateFailureAction) => {
		const {
			meta: { analyticsEvent },
		} = action;

		if (!analyticsEvent) {
			return null;
		}

		const opEvent = analyticsEvent.clone();

		if (opEvent) {
			fireOperationalAnalytics(opEvent, 'ui taskFail', {
				task: 'createSprint',
			});
		}

		return null;
	};
